<template>
    <!-- DESCR：审稿人审稿页面 -->
    <div class="managereview-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="24" class="login-title">
                <div class="desc-box">
                    <div class="title">My Review Requests for {{ $route.query.acronym }}</div>
                    <br />
                    <div class="info">
                        The table below shows all your review requests. To process the request, click the "button" to
                        perform the operation
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="10" justify="center">
            <el-col :span="24">
                <div class="click-tips">
                    <span class="text-line">Use of colors:</span>
                    <div style="display: flex;justify-content: space-between;">
                        <div>
                            <el-tag style="margin-right:10px;" @click="tips1">submission not accessed</el-tag>
                            <el-tag type="warning" @click="tips3" style="margin-right:10px;">request accepted, no review</el-tag>
                            <el-tag type="success" @click="tips2">review added to ConfChair</el-tag>
                        </div>
                        <div>
                            <el-tag style="margin-right:10px;" effect="plain" @click="confdesc">Conference Desc</el-tag>
                        </div>
                    </div>
                </div>
                <el-table :data="conferencePaperList" style="width: 100%" border :row-class-name="tableRowClassName">
                    <el-table-column label="Id" width="120" header-align="center" align="center">
                        <template #default="scope">
                            <span style="margin-left: 10px">{{ scope.row.autoid }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Authors" header-align="center" width="350">
                        <template #default="scope">
                            <el-text class="mx-1" size="small">{{ scope.row.authors }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="Title" header-align="center">
                        <template #default="scope">
                            <el-text class="mx-1" size="small">{{ scope.row.title }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="PC member" header-align="center" width="110">
                        <template #default="scope">
                            <el-text class="mx-1" size="small">{{ scope.row.priesidentname }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="Status" header-align="center" align="center" width="220">
                        <template #default="scope">
                            <el-text class="mx-1" size="small">{{ scope.row.status }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="Status Date" header-align="center" align="center" width="145">
                        <template #default="scope">
                            <el-text class="mx-1" size="small">{{ scope.row.createtime }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="operate" header-align="center" align="center" width="130">
                        <template #default="scope">
                            <el-button size="small" @click="examine(scope.$index, scope.row)" type="primary" :icon="View">
                                information
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex"
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import { View, Select } from '@element-plus/icons-vue'
import { useMessage } from 'naive-ui'
import request from "../../network/request"


const route = useRoute()
const conferencePaperList = ref([])
const router = useRouter()

onMounted(() => {
    // 获取审稿列表信息
    request.get(`/paper/reviewerlist?pagenum=1&pagesize=10&cid=${route.query.cid}`).then((res) => {
        // 重构列表数据结构（authornamelist、isCorresponding、status）
        let datalist = res.data.list;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
                author.isCorresponding = author.isCorresponding == 0 ? false : true
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            let status;
            if (item.isaccept == 0) {
                status = "submission not accessed"
            }
            else if (item.isaccept == 1) {
                status = "request accepted, no review"
            }
            else {
                status = "review added to ConfChair"
            }
            if (item.isaccept != null) {
                conferencePaperList.value.push({ id: item.id, pid: item.pid, authors: authornames, title: title, priesidentname: item.priesidentname, status: status, isaccept: item.isaccept, createtime: item.createtime,autoid:item.autoid })
            }
        })
    })
})


// 审稿论文
const examine = (index, row) => {
    request.get(`/paper/access?pid=${row.pid}`).then((res) => {
        if (res.code == 200) {
            router.push(`/common/detailpaper?pid=${row.pid}&role=2&acronym=${route.query.acronym}`)
        }
    })
}

// 我的会议列表表格行样式
const tableRowClassName = ({ row, rowIndex, }) => {
    if (row.isaccept == 0) {
        return 'sg'
    }
    else if (row.isaccept == 1) {
        return 'fw'
    }
    else {
        return 'ys'
    }

}

// 未提示交互效果
const tips1 = () => {
    ElNotification({
        title: 'submission not accessed',
        duration: 1500,
    })
}

const tips2 = () => {
    ElNotification({
        title: 'request accepted, no review',
        duration: 1500,
    })
}

const tips3 = () => {
    ElNotification({
        title: 'review added to ConfChair',
        duration: 1500,
    })
}

// 跳转到会议详细页
const confdesc = () => {
    let sublink = route.query.acronym.replace("_", "").replace(" ", "").toLowerCase()
    router.push(`/common/submitpaper?conf=${sublink}`)
}

</script>


<style lang="scss">
.managereview-container {
    position: absolute;
    top: 100px;
    left: 50px;
    right: 50px;
    bottom: 20px;

    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 5px;
            }
        }
    }

    .click-tips {
        font-size: 13px;

        .el-tag {
            cursor: pointer;
        }

        .text-line {
            border-bottom: 1px solid #88b5cb61;
            display: inline-block;
            margin-bottom: 20px;
            padding-bottom: 5px;
        }

        div {
            margin-bottom: 10px;
        }
    }

    .el-table .sg {
        background-color: #75afff1f;
    }

    .el-table .fw {
        background-color: #ffda7314;
    }

    .el-table .ys {
        background-color: #def7e12e;
    }
}
</style>